export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-quadtree/src/root.js
// module id = ../../../../d3-quadtree/src/root.js
// module chunks = 4